import { createContext, useContext, type Context } from 'react';

import type { ReportedCreditDenial } from '../common/credits-backend/types';
import type { CreditsState } from './credits-session-state.types';

export const EMPTY_CREDITS_STATE: CreditsState = Object.freeze({
	bannerState: null,
	bannerStateChange: null,
});

export const CreditsStateContext: Context<CreditsState | null> = createContext<CreditsState | null>(
	null,
);

export const useCreditsStateContext: () => CreditsState | null = () =>
	useContext(CreditsStateContext);

export type ReportCreditDenial = (denial: ReportedCreditDenial) => void;

export const CreditsDenialReporterContext: Context<ReportCreditDenial | null> =
	createContext<ReportCreditDenial | null>(null);

export const useCreditsDenialReporterContext: () => ReportCreditDenial | null = () =>
	useContext(CreditsDenialReporterContext);
